<template>


   <div  v-show="this.$store.state.isShowModal_declare"  class="box">


<div class="btn"  >
  <i class="icon-close"  @click="hide" aria-hidden="true"></i>
</div>

        <div class="title">

            <img  src="@/assets/tiffany.svg" />

        </div>

        <div class="content">

            <p v-show="this.$store.state.lang==='cn'">
 本網頁內的所有資料,包括任何圖片、插圖、透視圖、 模型、設計圖、繪圖、文字描述或其他資料,僅供參考或識別之用,並不構成或被視為發展商的任何明示或隱含的要約承諾或保證。圖片或經電腦模擬及簡化處理,並不按比例。所有資料均以承諾買賣合約的條款及條件為準。

發展物業的詳情包括所述的資料須經當地政府部門的批准。發展商保留權利在無須給予任何通知的情況下,按當地政府部門要求或其他原因,改動及撤銷任何有關樓宇的設計、規格、特色、平面圖、時間表、上蓋物業之分佈、 物料以及任何有關設備或服務之供應或其用途。

會所設施、佈局、間隔、裝飾及設計以入伙時所提供為準。

住客會所附屬康樂設施於入伙時未必能即時啟用。

部份禮賓服務及會所設施須額外收費。

發展商保留一切權利,並無須給予事先通知,以類似質素及等級的材料代替於標準用料及設備中所列的擬用材料。

在此建議各準買家親身到訪物業周圍以充份了解其環境,如有疑問或欲知個別內容之詳情,請向其銷售代理或有關行業之專業人士詢問查證。

本網頁中英版本文字若有差異,一切內容以中文版本為準。

</p>
        <p v-show="this.$store.state.lang==='sc'">

本网页内的所有资料,包括任何图片、插图、透视图、 模型、设计图、绘图、文字描述或其他资料,仅供参考或识别之用,并不构成或被视为发展商的任何明示或隐含的要约承诺或保证。图片或经电脑模拟及简化处理,并不按比例。所有资料均以承诺买卖合约的条款及条件为准

发展物业的详情包括所述的资料须经当地政府部门的批准。发展商保留权利在无须给予任何通知的情况下,按当地政府部门要求或其他原因,改动及撤销任何有关楼宇的设计、规格、特色、平面图、时间表、上盖物业之分布、 物料以及任何有关设备或服务之供应或其用途。

会所设施、布局、间隔、装饰及设计以入伙时所提供为准。

住客会所附属康乐设施于入伙时未必能即时启用。

部份礼宾服务及会所设施须额外收费。

发展商保留一切权利,并无须给予事先通知,以类似质素及等级的材料代替于标准用料及设备中所列的拟用材料。

在此建议各准买家亲身到访物业周围以充份了解其环境,如有疑问或欲知个别内容之详情,请向其销售代理或有关行业之专业人士询问查证。

本网页中英版本文字若有差异,一切内容以中文版本为准。

</p>
            

        </div>



   
        

    </div>

    <div  v-show="this.$store.state.isShowModal_declare"  @click="hide" class="mask"></div>
</template>
<script>




export default {
  name: 'DiyModalDeclare',
  data () {
      return {
isShow:true
      }
  },
    methods: {

        show () {
            this.$data.isShow = true;
        },
        hide () {
            this.$store.state.isShowModal_declare = false
            document.querySelector('audio').play();
            this.$store.state.soundOn = true

        }

    },mounted:function(){
        console.log(this.$store.state.count)
    }
}





</script>


<style scoped>



.icon-close{
  font-size: 29px;
    padding-top: 1%;
    padding-right: 1%;
}

.box>div:not(.btn){

width: 80%;
display: flex;
justify-content: center;
align-items: center;
position: relative;
margin: 0 auto;
}

.box .btn{
    display: flex;
    justify-content: end;
}

.icon-close:before {
    content: "\f109";
}
.title img{
    height: 110px;
    object-fit: cover;
}

.content {
    display: flex;




}
.content  {

text-align: justify;

}


.box .partition .partition-title {
    box-sizing: border-box;
    padding: 30px;
    width: 100%;
    text-align: center;
    letter-spacing: 1px;
    font-size: 20px;
    font-weight: 300;
}
.box{
  width: 70%;
    left: 15%;
    right: 15%;  
position:absolute;
z-index: 99999;
background: #fff;

top:15%;
bottom:15%;

    
}



 .box p{

 }

.box .github-btn {
    border-color: #dba226;
    color: #dba226;
}
 .box .box-part {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 100%;
   
}
.box .facebook-btn {
    border-color: #3880ff;
    color: #3880ff;
}
 .box input[type=text],.box input[type=number] {
    display: block;
    box-sizing: border-box;
    margin-bottom: 4px;
    width: 100%;
    font-size: 12px;
    line-height: 2;
    border: 0;
    border-bottom: 1px solid #dddedf;
    padding: 4px 8px;
    font-family: inherit;
    transition: all .5s;
    outline: none;
}
.box .large-btn {
    width: 100%;
    background: #fff;
}
.box button {
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    letter-spacing: 1px;
    font-family: Open Sans,sans-serif;
    font-weight: 400;
    /* min-width: 140px; */
    margin-top: 8px;
    color: #8b8c8d;
    cursor: pointer;
    border: 1px solid #dddedf;
    text-transform: uppercase;
    transition: all .1s;
    font-size: 10px;
    outline: none;
}

.box .partition .partition-form {
    padding: 0 20px;
    box-sizing: border-box;
}.box .button-set {
    margin-bottom: 8px;
}
.box #register-btn, .box #signin-btn {
    margin-left: 8px;
}



</style>


<!-- media -->
<style scoped>
@media   (min-width:1024px){
    
    .box input[type=text]{
        width:250px
    }

    .box button{
        width:100px ;
    }

 


    .box button{
       
        background: #846C32;
        color: #FFFFFF;
        border-radius:31px
    }

}



@media screen and (max-width: 767px), screen and (max-height: 400px){
     .box input[type=text]{
        width:220px
    }
.box {
    width: 85%;
    left: 7.5%;
    right: 15%;
    position: absolute;
    z-index: 99999;
    background: #fff;
    top: 10%;
    bottom: 15%;
}

    .icon-close{
        font-size: 20px;
    }
.box>div:not(.btn) {
    width: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 0 auto;
}

    .box .title img{
        height: 60px;
      
    }

    .content {
    text-align: justify;
    line-height: 20px;
}

     .box .content{
        font-size: 10px;
     }


    .box button{
        width:100px ;
        background: #846C32;
        color: #FFFFFF;
        border-radius:31px
    }
}




</style>